export default "__VITE_ASSET__IWqsrhRT__"